import BaseModel from 'models/base-model';
import clonedeep from 'lodash.clonedeep';
import { getTranslationByKey } from 'constants/common/feature-common-utils';

const ERROR_STATUS_UNAVAILABLE = 'common.error-status-unavailable';
const ERROR_MESSAGE_UNAVAILABLE = 'common.error-message-unavailable';
const FAILED_URL_UNAVAILABLE = 'common.failed-url-unavailable';
const STACK_TRACE_UNAVAILABLE = 'common.stack-trace-unavailable';
const ERROR_NOT_HANDLED = 'common.error-not-handled';

export default class ApiError extends BaseModel({
  apiErrorArray: [],
}) {
  clearErrorData() {
    return this.merge({
      apiErrorArray: [],
    });
  }

  updateErrorData(payload) {
    const { locale, response } = payload;
    const failedURLResponse = response.config
      ? response.config.url
      : getTranslationByKey({ locale, key: FAILED_URL_UNAVAILABLE });

    let apiErrorArrayCopy = clonedeep(this.apiErrorArray);
    let newErrorObj = {};

    // depending on the error, the backend may return
    // a response a different format
    if (typeof response.data === 'string') {
      newErrorObj.errorStatus = response.status
        ? response.status
        : getTranslationByKey({ locale, key: ERROR_STATUS_UNAVAILABLE });
      newErrorObj.errorMessage =
        response.data !== ''
          ? response.data
          : getTranslationByKey({ locale, key: ERROR_MESSAGE_UNAVAILABLE });
      newErrorObj.failedUrl = failedURLResponse;
      newErrorObj.stackTrace = getTranslationByKey({
        locale,
        key: STACK_TRACE_UNAVAILABLE,
      });
      newErrorObj.handledErrorJsonString = getTranslationByKey({
        locale,
        key: ERROR_NOT_HANDLED,
      });
    } else {
      const errorData = response.data;
      newErrorObj.errorStatus = errorData.status
        ? errorData.status
        : getTranslationByKey({ locale, key: ERROR_STATUS_UNAVAILABLE });
      newErrorObj.errorMessage = errorData.errorMsg
        ? errorData.errorMsg
        : getTranslationByKey({ locale, key: ERROR_MESSAGE_UNAVAILABLE });
      newErrorObj.failedUrl = failedURLResponse;
      newErrorObj.stackTrace = getTranslationByKey({
        locale,
        key: STACK_TRACE_UNAVAILABLE,
      });
      newErrorObj.handledErrorJsonString = getTranslationByKey({
        locale,
        key: ERROR_NOT_HANDLED,
      });
    }

    apiErrorArrayCopy.push(newErrorObj);
    return this.merge({ apiErrorArray: apiErrorArrayCopy });
  }

  updateErrorStackTrace(payload) {
    const { locale, response } = payload;
    const stack = response;
    let apiErrorArrayCopy = clonedeep(this.apiErrorArray);

    if (apiErrorArrayCopy.length === 0) {
      let newErrorObj = {};
      newErrorObj.errorStatus = getTranslationByKey({
        locale,
        key: ERROR_STATUS_UNAVAILABLE,
      });
      newErrorObj.errorMessage = getTranslationByKey({
        locale,
        key: ERROR_MESSAGE_UNAVAILABLE,
      });
      newErrorObj.failedURL = getTranslationByKey({
        locale,
        key: FAILED_URL_UNAVAILABLE,
      });
      newErrorObj.handledErrorJsonString = getTranslationByKey({
        locale,
        key: ERROR_NOT_HANDLED,
      });
      newErrorObj.stackTrace = stack;
      apiErrorArrayCopy.push(newErrorObj);
    } else {
      apiErrorArrayCopy[apiErrorArrayCopy.length - 1].stackTrace = stack;
    }

    return this.merge({ apiErrorArray: apiErrorArrayCopy });
  }

  updateCatchedErrorJson(payload) {
    const { locale, response } = payload;
    const handledErrorJsonString = response;
    let apiErrorArrayCopy = clonedeep(this.apiErrorArray);

    if (apiErrorArrayCopy.length === 0) {
      let newErrorObj = {};
      newErrorObj.errorStatus = getTranslationByKey({
        locale,
        key: ERROR_STATUS_UNAVAILABLE,
      });
      newErrorObj.errorMessage = getTranslationByKey({
        locale,
        key: ERROR_MESSAGE_UNAVAILABLE,
      });
      newErrorObj.failedURL = getTranslationByKey({
        locale,
        key: FAILED_URL_UNAVAILABLE,
      });
      newErrorObj.handledErrorJsonString = handledErrorJsonString;
      apiErrorArrayCopy.push(newErrorObj);
    } else {
      apiErrorArrayCopy[apiErrorArrayCopy.length - 1].handledErrorJsonString =
        handledErrorJsonString;
    }

    return this.merge({ apiErrorArray: apiErrorArrayCopy });
  }
  getReadOnlyErrorMessageToDisplay() {
    // const { locale, response } = payload;
    if (this.apiErrorArray && this.apiErrorArray.length > 0) {
      return this.apiErrorArray[0].errorMessage;
    } else {
      return getTranslationByKey({
        locale: 'en-US',
        key: ERROR_MESSAGE_UNAVAILABLE,
      });
    }
  }

  getDetailsToCopyToClipboard() {
    if (this.apiErrorArray) {
      let errorDetails = '';
      for (let index = 0; index < this.apiErrorArray.length; index++) {
        const error = this.apiErrorArray[index];
        const {
          errorStatus,
          errorMessage,
          failedUrl,
          stackTrace,
          handledErrorJsonString,
        } = error;
        const newErrorDetail = `Error Status: ${errorStatus}.\n Error Message: ${errorMessage} \n Failed URL: ${failedUrl}.\n\n Catched Error Json: ${handledErrorJsonString} \n\n $ Browser Generated Stack Trace: ${stackTrace}. `;
        errorDetails += newErrorDetail + '\n';
      }
      return errorDetails;
    } else {
      return 'Details not available';
    }
  }
}
